import { SVGProps } from 'react';

const Columns3Cog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M10.5 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5.5m-6.7 9.1 1-.4M15 3v7.5m.2 6.4-.9-.3m2.3 5.1.3-.9m-.1-5.5-.4-1m2.7.9.3-.9m.2 7.4-.4-1m1.5-3.9 1-.4m0 3-.9-.3M9 3v18m12-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default Columns3Cog;
